const createRemoteConfigApi = ({ remoteConfig }) => ({
    remoteConfig: {
        get: remoteConfig.get,
        getAll: remoteConfig.getAll,
        update: remoteConfig.update,
    },
});
const remoteConfigApiDefinition = {
    id: 'remoteConfigApi',
    type: 'api',
    factory: createRemoteConfigApi,
    dependencies: ['remoteConfig'],
};
export default remoteConfigApiDefinition;
